// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__66GP6","img":"NotFound_img__M52pI","text":"NotFound_text__QDmoJ"};